export default __webpack_public_path__ + "static/media/v-executive.bd44d786.jpeg";